/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ClaimAccountDTO } from './ClaimAccountDTO';
import type { ClaimImageDTO } from './ClaimImageDTO';
import type { ClaimInvoiceDTO } from './ClaimInvoiceDTO';
import type { ClaimItemDTO } from './ClaimItemDTO';
import type { ClaimNoteDTO } from './ClaimNoteDTO';
import type { ClaimShopDTO } from './ClaimShopDTO';
import type { ClaimStatusDTO } from './ClaimStatusDTO';
export type ClaimDTO = {
    claimId?: string;
    claimNo?: string;
    shopId?: string;
    shopName?: string;
    customerFirstName?: string;
    customerLastName?: string;
    customerCitizenId?: string;
    customerPassportNo?: string;
    customerPhoneNumber?: string;
    customerFacebookUrl?: string;
    customerLineId?: string;
    customerNote?: string;
    type?: ClaimDTO.type;
    modeType?: ClaimDTO.modeType;
    estimatePrice?: number;
    isDeposit?: boolean;
    status?: ClaimDTO.status;
    importedAt?: string;
    appointmentAt?: string;
    brand?: string;
    version?: string;
    imei?: string;
    serialNumber?: string;
    battery?: number;
    defect?: string;
    lockType?: ClaimDTO.lockType;
    lockPassword?: string;
    productNote?: string;
    guaranteeDay?: number;
    guaranteeHtmlDetail?: string;
    remark?: string;
    hirePrice?: number;
    deliveryDate?: string;
    selectedShopId?: string;
    problemDetails?: Array<string>;
    items?: Array<ClaimItemDTO>;
    images?: Array<ClaimImageDTO>;
    accounts?: Array<ClaimAccountDTO>;
    invoices?: Array<ClaimInvoiceDTO>;
    hireInvoices?: Array<ClaimInvoiceDTO>;
    notes?: Array<ClaimNoteDTO>;
    statusHistory?: Array<ClaimStatusDTO>;
    countRequestClaim?: number;
    isSelfClaim?: boolean;
    isReceiveCentral?: boolean;
    depositAmount?: number;
    shopNameReceiveCentral?: string;
    ownShop?: ClaimShopDTO;
    shopsCentralClaim?: Array<ClaimShopDTO>;
};
export namespace ClaimDTO {
    export enum type {
        SELF = 'SELF',
        RECEIVE_CENTRAL = 'RECEIVE_CENTRAL',
        SEND_CENTRAL = 'SEND_CENTRAL',
    }
    export enum modeType {
        NONE = 'NONE',
        WAIT_SELECTION = 'WAIT_SELECTION',
        WAIT_APPROVAL = 'WAIT_APPROVAL',
        APPROVED = 'APPROVED',
        NOT_APPROVED = 'NOT_APPROVED',
    }
    export enum status {
        NONE = 'NONE',
        RECEIVE = 'RECEIVE',
        ORDER_SPARE = 'ORDER_SPARE',
        RECEIVE_SPARE = 'RECEIVE_SPARE',
        REPAIRING = 'REPAIRING',
        TESTING = 'TESTING',
        REPAIR_SUCCESS = 'REPAIR_SUCCESS',
        REPAIR_FAIL = 'REPAIR_FAIL',
        CANCEL = 'CANCEL',
    }
    export enum lockType {
        NONE = 'NONE',
        PIN = 'PIN',
        PASSWORD = 'PASSWORD',
        PATTERN = 'PATTERN',
    }
}

